import { useFetch } from "../lib/useFetch";
import { SelectDictionary } from "./ui/select-dictionary";

export function CurrencySelect(props: { 
  onChange: (code: string) => void; 
  value?: string;
  disabled?: boolean;
}) {
  const { fetch } = useFetch();
  const getCurrencies = () =>
    fetch<{ data: { name: string; code: string }[] }>("/api/currencies", "GET").then((d) =>
      d.data.map((r) => ({ value: r.code, text: r.name })),
    );
  return <SelectDictionary getOptions={getCurrencies} onChange={props.onChange} value={props.value ?? "EUR"} disabled={props.disabled} />;
}
